import { ENVIRONMENT_LABEL_KEY, UNIT_ID_LABEL_KEY } from 'src/common/consts/platformConfigConsts';

export const WFA_SESSIONS_LABEL_KEY_ORDER = [
	UNIT_ID_LABEL_KEY,
	ENVIRONMENT_LABEL_KEY,
	'flow',
	'team'
];

export const WFA_ADDITIONAL_LABBELS_SIZE_LIMIT = 2;
